module.exports = "<div class=\"form-control component-songrid-control\"> <div class=ui-songrid-box> <div class=songGrid></div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/correspondence-control/correspondence-control.wx.html
// module id = 4722
// module chunks = 50